import { root } from '@estee/elc-universal-utils';

const PRODUCT_ID_POSITION = 2;

export const getProductIdFromUrl = () => {
    const path = root.location.pathname;
    const splitPath = path.split('/');
    const productIndex = splitPath.indexOf('product');

    if (productIndex > 0) {
        return splitPath[productIndex + PRODUCT_ID_POSITION];
    }
};
